import styled from "styled-components"
import { Link } from "gatsby"

export const LinksContainer = styled.ul`
  position: fixed;
  left: 60px;
  top: 45px;
  margin: 0;
  padding: 0;
  color: ${({ light, active }) => (light && !active ? "black" : "white")};
  transition: color 0.5s ease-in-out;
  z-index: 5;
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tabletSmall}) {
    left: 45px;
  }

  @media screen and (max-width: 400px) {
    left: 20px;
  }
`
